module.exports = __webpack_public_path__ + "static/couture01-sq-81f24d4848d20ce36b7135ef09a7afe9.png";